import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import { useQueries } from '@tanstack/react-query';
import { Link, useParams } from "react-router";

import { getBasketData} from "../router";

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import InstanceEventSummary from '../components/instance-event-summary';
import InstanceBasketSummary from '../components/instance-basket-summary';
import ExtrasInstance from './extras-instance';
import BackButton from '../components/back-button';
import LoadingIndicator from '../components/loading-indicator';

export default function Extras(props) {

    const { instanceId } = useParams();
    const { data: basketData, isFetching } = getBasketData();

    const [groupedInstances, setGroupedInstances] = useState(null);
    const [instanceTickets, setInstanceTickets] = useState(null);

    const query_ids = CONSTANTS.SUPPLEMENTARY_INSTANCES;
    const query_map = query_ids?.map((instance_id) => ({
            queryKey: ['instance', instance_id],
            queryFn: () => QUERIES.getInstance(instance_id), 
            refetchOnWindowFocus: false
    }));

    const combinedExtras = useQueries({
        queries: query_map,
        combine: (results) => {
            return {
                data: results.map((result) => result.data),
                pending: results.some((result) => result.isPending),
            }
        },
    });

    useEffect(() => {
        if (!combinedExtras || !combinedExtras.data || combinedExtras.pending) return;

        let primary_instances = [];
        let secondary_instances = [];

        combinedExtras.data.forEach((instance) => {
            const section = instance.event?.attribute_ExtrasSection;

            if (section === "Secondary") {
                secondary_instances.push(instance);
            } else {
                primary_instances.push(instance);
            }
        });

        setGroupedInstances([
            {
                title: "Enhance your experience",
                instances: primary_instances,
            },
            {
                title: "Protect your booking",
                instances: secondary_instances,
            },
        ]);
    }, [combinedExtras]);


    useEffect(() => {
        if (!basketData) return;

        let tickets = UTILS.getTicketsByInstance(basketData.tickets);
        setInstanceTickets(tickets);
    }, [basketData])


    return (
        <div className='booking-pathway__container booking-pathway__extras'>
            <InstanceEventSummary />
            
            <div className='booking-pathway__main-content'>
                {!combinedExtras.pending && groupedInstances ? (
                    groupedInstances.map((group) =>
                        group.instances.length ? (
                            <div key={group.title} className='extras-group'>
                                <h2 className='extras-group__title'>{group.title}</h2>

                                {group.instances.map((instance) => (
                                    <ExtrasInstance key={instance.id} instance={instance} instanceTickets={instanceTickets} />
                                ))}

                            </div>
                        ) : null
                    )
                ) : 
                    <LoadingIndicator />
                }
            </div>

            <InstanceBasketSummary />

            <div className='booking-pathway__footer'>
                <Link to={CONSTANTS.EVENT?.attributes?.MultiBuy ? `/book-online/${instanceId}/multibuy` : '/basket'} className='btn btn--primary' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Continue</Link>
                <BackButton />             
            </div>
        </div>
    );
}